import React from "react"
import Text from "./input.module.css"

export default function text_input({value, setValue, texto, readOnly}){
    function salvar(e){
        if (setValue) { // só altera se vier setValue
            let valor = e.target.value;
            setValue(valor);
        }
    }

    return(
        <div className={Text.esquerda}>
            <label className={Text.label}><b>{texto}</b></label><br />
            <input type="text" id="text" placeholder="XXXXXXXXXXXXXXXXXXX" 
            required className={Text.input} autoComplete="off" value={value} onChange={salvar}
            readOnly={readOnly} /><br />
        </div>
    )
}